import React from 'react';
import { SITE_URL } from '../lib/seo';

const AREAS = ['Old Bridge', 'Laurence Harbor', 'Matawan', 'South Amboy', 'Sayreville', 'Keyport', 'Aberdeen'];

const buildSchema = (site) => ({
  '@context': 'https://schema.org',
  '@type': 'Church',
  name: 'Life Church of New Jersey',
  legalName: 'Word of Life Apostolic Center, Inc.',
  url: SITE_URL,
  logo: `${SITE_URL}/logo-new.png`,
  image: `${SITE_URL}/logo-new.png`,
  telephone: '+1-732-801-2050',
  email: 'info@lifechurchofnj.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '22 Laurence Parkway',
    addressLocality: 'Laurence Harbor',
    addressRegion: 'NJ',
    postalCode: '08879',
    addressCountry: 'US',
  },
  areaServed: [
    ...AREAS.map((name) => ({ '@type': 'City', name: `${name}, NJ` })),
    { '@type': 'AdministrativeArea', name: 'Middlesex County, NJ' },
  ],
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: 'https://schema.org/Sunday', opens: '12:00', closes: '13:30' },
  ],
  event: [
    {
      '@type': 'Event',
      name: 'Sunday Worship Service',
      eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
      eventSchedule: { '@type': 'Schedule', byDay: 'https://schema.org/Sunday', startTime: '12:00', endTime: '13:30', repeatFrequency: 'P1W', scheduleTimezone: 'America/New_York' },
      location: { '@type': 'Place', name: 'Life Church of New Jersey', address: '22 Laurence Parkway, Laurence Harbor (Old Bridge Township), NJ 08879' },
    },
    {
      '@type': 'Event',
      name: 'Wednesday Bible Study (online via Zoom)',
      eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
      eventSchedule: { '@type': 'Schedule', byDay: 'https://schema.org/Wednesday', startTime: '20:00', repeatFrequency: 'P1W', scheduleTimezone: 'America/New_York' },
      location: { '@type': 'VirtualLocation', name: 'Zoom', url: `${SITE_URL}/bible-study` },
    },
  ],
  sameAs: [site.youtube_url || 'https://www.youtube.com/@LifeChurchofNJ', site.instagram_url, site.facebook_url].filter(Boolean),
});

/** schema.org Church data for Google (homepage only). */
export const ChurchJsonLd = ({ site }) => (
  <script type="application/ld+json" data-testid="church-jsonld" dangerouslySetInnerHTML={{ __html: JSON.stringify(buildSchema(site)) }} />
);
